import { StyleSheet } from "react-native";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderColor: "lightgray",
    position: "relative",
    zIndex: 20,
  },
  text: {
    fontSize: 16,
    color: "black",
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
  },
  backButton: {
    minWidth: 64,
    minHeight: 36,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  backText: {
    color: "black",
    fontSize: 14,
    fontWeight: "600",
  },
  menuButton: {
    width: 44,
    height: 44,
    alignItems: "center",
    justifyContent: "center",
  },
  menuBackdrop: {
    position: "fixed" as never,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 29,
  },
  menuPanel: {
    position: "absolute",
    top: 58,
    right: 12,
    width: 176,
    paddingVertical: 6,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#d6d6d6",
    backgroundColor: "white",
    shadowColor: "#000",
    shadowOpacity: 0.18,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 5 },
    elevation: 12,
    zIndex: 30,
  },
  menuItem: {
    minHeight: 44,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  menuItemText: {
    color: "#222",
    fontSize: 14,
  },
  logoutText: {
    color: "#d74646",
    fontSize: 14,
  },
});

export default styles;
